import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useAuthStore } from '../stores/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'users' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'users' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'user-detail',
        path: 'users/:id',
        component: () => import('../pages/users/UserDetailPage.vue'),
      },
      {
        name: 'promo-codes',
        path: 'promo-codes',
        component: () => import('../pages/promo-codes/PromoCodesPage.vue'),
      },
      {
        name: 'promo-code-detail',
        path: 'promo-codes/:id',
        component: () => import('../pages/promo-codes/PromoCodeDetailPage.vue'),
      },
      {
        name: 'partners',
        path: 'partners',
        component: () => import('../pages/partners/PartnersPage.vue'),
      },
      {
        name: 'partner-detail',
        path: 'partners/:id',
        component: () => import('../pages/partners/PartnerDetailPage.vue'),
      },
      {
        name: 'utm-builder',
        path: 'utm-builder',
        component: () => import('../pages/utm-builder/UtmBuilderPage.vue'),
      },
      {
        name: 'finance',
        path: 'finance',
        component: () => import('../pages/finance/FinancePage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (to.name === 'login') {
    if (!auth.isAuthenticated) await auth.checkAuth()
    if (auth.isAuthenticated) return { name: 'users' }
    return true
  }

  if (to.matched.some((record) => record.name === 'admin') && !auth.isAuthenticated) {
    await auth.checkAuth()
    if (!auth.isAuthenticated) return { name: 'login' }
  }

  return true
})

export default router
